var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"jrm-block jrm-size-100 jrm-height-auto",attrs:{"width":"200","height":"200","src":require("../../../../assets/images/product-placeholder.png"),"alt":"Заглушка фотографии"}})}
var staticRenderFns = []

export { render, staticRenderFns }